import styled from 'styled-components';

export const Content = styled.div`
 flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
  font-family: 'Inter', sans-serif;
  overflow: hidden;

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`;

export const SectionName = styled.h2`
  font-size: 1.4rem;
  font-weight: 700;
  width: fit-content;
  padding-right: 1rem;
  margin-right: 1rem;
`